import React from "react";
import { Anchor } from 'antd';
import { config } from "util/config";

export default class SectionNavigation extends React.Component {
  constructor(props) {
    super();
    this.state = {
      page: null
    }
  };

  //查询该页面的config
  async componentDidMount() {
    this.props.page.sectionList.map(item => {
      item.className = '';
      return item;
    });
    setTimeout(() => {
      this.setState({ page: this.props.page });
    }, config.setTimeoutMilliSecond);
  }

  goToSection(name) {
    let height = 0;
    this.state.page.sectionList.map((section, i) => {
      let control = document.getElementsByClassName(section.name)[0];
      if (section.name !== name) {
        control.style.borderColor = '#D5D5D5';
        control.style.boxShadow = '0 0.46875rem 2.1875rem rgb(4 9 20 / 3%), 0 0.9375rem 1.40625rem rgb(4 9 20 / 3%), 0 0.25rem 0.53125rem rgb(4 9 20 / 5%), 0 0.125rem 0.1875rem rgb(4 9 20 / 3%)';
        let rect = control.getBoundingClientRect();
        height += rect.height + 32;
      } else {
        control.style.borderColor = '#549BFF';
        control.style.boxShadow = 'inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(84 155 255 / 60%)';
        window.scrollTo(0, height);
      }
    });
  }

  render() {
    return (
      this.state.page != null ? <div className="section-navigation" style={{ padding: '6px 36px' }}>
        {
          this.state.page.sectionList.map((section, i) => <span className={'anchor-trigger ' + (section.className !== undefined ? section.className : '')} key={i} onClick={() => {
            this.goToSection(section.name);
          }}>{section.componentList.filter(c => c.type === 'View')[0].title}</span>)
        }
      </div> : <></>
    );
  }
}
